<template>
  <nav
    aria-label="Barre latérale"
    class="hidden md:block md:flex-shrink-0 md:bg-white md:overflow-y-auto shadow-lg"
  >
    <div class="relative px-5 pb-4 pt-20 space-y-3 h-full flex flex-col justify-between w-24">
      <div class="flex flex-col space-y-3">
        <TheSideBarIcon label="Accueil" route="home" icon="home" />
        <TheSideBarIcon label="Relation Patients" route="patient-administration.home" icon="account-multiple" />
        <TheSideBarIcon label="Rupture" route="disruption-logistics" icon="truck" />
        <TheSideBarIcon label="Modules" route="extension-store" icon="view-grid-plus" />
        <TheSideBarIcon label="Liens Ville - Hôpital" route="hospital" icon="hospital-building" />
        <TheSideBarIcon v-if="experimentalFeatures" label="Intelligence Artificielle" route="knowledgeables" icon="ai" />
        <TheSideBarIcon label="Mes partenaires" route="laboratories" icon="handshake" />
      </div>
      <div class="flex flex-col space-y-3 border-t border-gray-300 pt-3">
        <TheSideBarIcon label="Paramètres" route="notification.preference" icon="cog" />
        <TheSideBarIcon label="Service Client" route="support" icon="headset" />
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapState} from "pinia";
import {useSystemStore} from "@/stores/system.store";
import TheSideBarIcon from "@/core/components/navigation-bar/TheSideBarIcon.vue";

export default defineComponent({
    components: {TheSideBarIcon},
    data() {
        return {
            experimentalFeatures: false
        };
    },
    computed: {
        ...mapState(useSystemStore, ['notificationCount', "environment"]),
    },
    created() {
        window.addEventListener('keydown', this.toggleExperimentalMenu);
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.toggleExperimentalMenu);
    },
    methods: {
        /**
         * Toggle experimental menu
         *
         * @param event
         */
        toggleExperimentalMenu(event: KeyboardEvent) {
            if (event.key === 'x' && event.ctrlKey) {
                this.experimentalFeatures = !this.experimentalFeatures;
                window.ipcRenderer.invoke('toggle-developer-mode', this.experimentalFeatures);
            }
        }
    }
});
</script>
